export default "__VITE_ASSET__c24d4cc2__"